import { ModelType } from "@/types/modelTypes";

// получение постфикса с именем модели в зависимости от версии модели
const getPostfixWithModelName = (activeModelVersion: ModelType, modelName: string): string => {
	if (activeModelVersion === "future") return modelName + "-new";
	else if (activeModelVersion === "previous") return modelName + "-backup";
	else return modelName;
};

export default getPostfixWithModelName;
